<div class="template-profiles" data-automation-id="template-profiles-container">
    <div class="header-bar" data-automation-id="template-profiles-header">
        <button type="button" data-automation-id="template-profiles-save-button" class="primary-button" *ngIf="hasCreatePermissions"
            (click)="saveChanges()" [disabled]="isDisabled()">Save</button>
        <button type="button" data-automation-id="template-profiles-discard-changes-button" *ngIf="hasCreatePermissions"
            class="secondary-button discard-changes-button" (click)="discardChanges()" [disabled]="isDisabled()">Discard
            Changes</button>
        <button type="button" data-automation-id="template-profiles-save-to-organizations-button" *ngIf="hasCreatePermissions"
            class="secondary-button" title="{{isDirty ? 'Please Save or Discard changes to enable this' : null}}"
            (click)="saveToOrganizations()" [disabled]="isBusy || isDirty">
            <i class="fa fa-save color-blue-01"></i>Save to Organizations ...
        </button>
        <button type="button" class="help-button" data-automation-id="template-profiles-help-button"
            (click)="openHelp()"><i class="fa fa-question"></i></button>
    </div>
    <div class="warning-msg" *ngIf="templateDeletedPresent">
        <i class="fa fa-exclamation-triangle warning"></i>One or more previously used templates are no longer available
        and have been grayed out below.
    </div>
    <form class="content" #contentForm="ngForm" data-automation-id="template-profiles-content" [resBusySpinner]="isBusy"
        [message]="isBusyMessage">
        <div class="grid-container">
            <res-generic-grid [gridName]="gridName" [automationId]="automationId" [pagerVisible]="false"
                [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs"
                [rowsHaveGrouping]="true" [requestInfo]="requestInfo" [rowClassRules]="rowClassRules"
                [cellClickedCallback]="cellClickedCallback">
            </res-generic-grid>
        </div>
    </form>
</div>